import Button from "@ingka/button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import crossIcon from "@ingka/ssr-icon/paths/cross";
import { REGISTERED, WAITING_LIST } from "../Register/enums";
import CancelRegistrationModal from "./CancelRegistrationModal";

type PropsType = {
  registrationState: string;
};

type CopyType = {
  [key: string]: {
    button: string;
  };
};

const CancelButton = styled(Button)`
  margin-top: var(--space-300);
`;

const CancelRegistration = ({ registrationState }: PropsType) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { t } = useTranslation();

  const copy: CopyType = {
    [REGISTERED]: {
      button: "event.cancelRegistration",
    },
    [WAITING_LIST]: {
      button: "event.leaveWaitingList",
    },
  };

  return (
    <>
      <CancelButton
        type="secondary"
        text={t(copy[registrationState].button)}
        ssrIcon={crossIcon}
        onClick={() => setShowCancelModal(true)}
      />
      <CancelRegistrationModal
        visible={showCancelModal}
        closeModal={() => setShowCancelModal(false)}
        registrationState={registrationState}
      />
    </>
  );
};

export default CancelRegistration;
